// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"e6d04423","252":"083725dd","453":"c51ba3a9","641":"de7a21a3"}[chunkId] + ".chunk.js";
};